import { QuestionTypeEnum } from '@/models/Question';
import { useTranslation } from 'react-i18next';
import { CorrectionResultCard } from '@/components/question/view/primitives/correction/CorrectionResultCard';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import { QuizCorrectionStatus, useQuizCorrection } from '@/components/question/view/typologies/quiz/useQuizCorrection';

const labelKeyByStatus: Record<
  QuizCorrectionStatus,
  'studentAnswer' | 'correct' | undefined
> = {
  incorrect: 'studentAnswer',
  missed: 'correct',
  correct: undefined,
};

export function QuizCorrectionView(
  props: QuestionViewPropsFor<QuestionTypeEnum.QUIZ>,
) {
  const { options } = useQuizCorrection(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });
  const showStudentAnswer = props.showStudentAnswerMessage ?? true;

  return (
    <div className="flex w-full flex-col gap-4">
      {options.map(option => {
        const labelKey = labelKeyByStatus[option.status];
        const isHiddenLabel =
          labelKey === 'studentAnswer' && !showStudentAnswer;
        return (
          <CorrectionResultCard
            key={option.id}
            option={option}
            label={labelKey && !isHiddenLabel ? t(labelKey) : undefined}
          />
        );
      })}
    </div>
  );
}
